<template>
  <div>

    <b-card-actions action-collapse title="Demurrage terme">
      <div>
         <div
          class="btn-delete-all text-right"
          @click="saveCommodity()"
        >
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
         </div>
        <div>
          <b-row
            class="mt-1"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Demurrage terme" label-for="commodity">
                   <b-form-input
                  placeholder="Demurrage terme"
                  required
                  id="cargoTemperature"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainCommodity()"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeCommodity()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>

            <hr />
          </b-row>


        
        </div>
      </div>
    </b-card-actions>

   <b-card-actions action-collapse title="Payment terms">
      <div>
        <div
            class="btn-delete-all text-right"
             @click="saveUn()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
        <div>
             <b-row
            class="mt-1"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Payment terms" label-for="un">
                   <b-form-input
                  placeholder="Payment terms"
                  required
                  id="un"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainUn()"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeUn()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>

            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
       <b-card-actions action-collapse title=" Global Transportation and Industrial Park (GTIP))">
      <div>
        <div
            class="btn-delete-all text-right"
             @click="saveClass()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
        <div>
         <b-row
            class="mt-1"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="GTIP" label-for="classe">
                    <b-form-input
                  placeholder="GTIP"
                  required
                  id="GTIP"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainClasse()"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeClasse()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
     
        </div>
      </div>
    </b-card-actions>
    <b-card-actions action-collapse title=" Package">
      <div>
        <div
            class="btn-delete-all text-right"
             @click="saveContainer()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
        <div>
          <b-row
            class="mt-1"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Package" label-for="Container">
                <b-form-input
                  placeholder="Package"
                  required
                  id="Package"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainContainer()"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeContainer()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
    <b-card-actions action-collapse title=" Currency">
      <div>
        <div
            class="btn-delete-all text-right"
             @click="saveContainer()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
        <div>
          <b-row
            class="mt-1"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Currency" label-for="Container">
                <b-form-input
                  placeholder="Currency"
                  required
                  id="Currency"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainContainer()"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeContainer()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
    <!-- <b-card-actions action-collapse title=" Date">

 </b-card-actions> -->
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      // form:{
      //     cy:0,
      //     sd:0,
      // },
      commodityTab: [
        {
          id: 1,
          title: null,
          _id:""
        },
      ],
      classeTab: [
        {
          id: 1,
          title: "",
           _id:""

        },
      ],
      unTab: [
        {
          id: 1,
          title: "",
           _id:""
        },
      ],
      containerTab: [
        {
          id: 1,
          title: "",
          _id:""
        },
      ],
      countriesFromAgent: null,
      countriesToAgent: null,
      nextTodoId: 2,
      // Portoptions: [
      //   { value: null, text: "Please select an option" },
      // ],
      commodityItems:{},
      containerItems:{},
      routesToSend:[]
    };
  },
  mounted() {
    //this.initTrHeight()
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getDataManagement()
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    async getDataManagement(){
      this.containerTab=[]
      this.commodityTab=[]
      this.classeTab=[]
      this.unTab=[]
      // container
        axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/containers"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.containerTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
        // commodity class un
         axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/commodities"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.commodityTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

       axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/classes"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.classeTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

         axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/uns"
        )
        .then((response) => {
          console.log("containers",response.data.data);
          response.data.data.forEach((element,index) => {
            this.unTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });


    },
    saveCommodity(){
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/commodities", this.commodityTab
        )
        .then((response) => {
          console.log("containers",response);
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "commodity updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    saveContainer(){
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/containers", this.containerTab
        )
        .then((response) => {
          console.log("containers",response);
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "Container updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    saveClass(){
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/classes", this.classeTab
        )
        .then((response) => {
          console.log("containers",response);
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "class updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    saveUn(){
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/uns", this.unTab
        )
        .then((response) => {
          console.log("containers",response);
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "un updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },

    repeateAgainCommodity() {
      this.commodityTab.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: "",
      });
      // console.log("object" + this.commodityTab[0].commodity);
      this.commodityTab.forEach((element) => console.log(element));
    },
    repeateAgainClasse() {
      this.classeTab.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: "",
      });
      this.classeTab.forEach((element) => console.log(element));
    },
    repeateAgainUn() {
      this.unTab.push({
        id: (this.nextTodoId += this.nextTodoId),
        un: "",
      });
      this.unTab.forEach((element) => console.log(element));
    },
    repeateAgainContainer() {
      this.containerTab.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: "",
      });
      this.containerTab.forEach((element) => console.log(element));
    },

    removeCommodity(i) {
      this.commodityTab.splice(i, 1);
    },
    removeClasse(i) {
      this.classeTab.splice(i, 1);
    },
    removeUn(i) {
      this.unTab.splice(i, 1);
    },
    removeContainer(i) {
      this.containerTab.splice(i, 1);
    },

  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
.btn-add {
  margin-top: 20px;
}
</style>